import get from 'lodash/get';
import { buildPreProdContentPath, EditorialReviewModel } from 'client/data/models/editorial-review';
import { getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { buildAllPhotosPath, PhotoflipperModel } from 'client/data/models/photoflipper';
import { getCoreMedia } from 'site-modules/shared/utils/core-page/core-media';
import { cloneParamsWithPubState } from 'site-modules/shared/utils/core-page/page-helpers';
import { CORE_GALLERY_SIZE } from 'site-modules/core-page/utils/constants';
import { getImageUrl, SOURCES } from 'client/utils/image-helpers';

export function getPreloadHeroImageAsset({
  modelState,
  makeModelSubmodelYear,
  photoParams,
  heroImageWidth,
  params,
  year,
  mobile,
}) {
  const firstContent = modelState.get(
    buildPreProdContentPath(getParamsFromVehicle(makeModelSubmodelYear)),
    EditorialReviewModel
  );
  const photos = modelState.get(
    buildAllPhotosPath({
      ...photoParams,
      pageNum: 1,
      imageSize: heroImageWidth,
    }),
    PhotoflipperModel
  );
  const coreMedia = getCoreMedia({
    params: cloneParamsWithPubState({
      params,
      year,
      isUsed: true,
    }),
    vehicle: makeModelSubmodelYear,
    firstContent,
    photos,
    isPreprod: false,
    defaultSize: mobile ? CORE_GALLERY_SIZE.MOBILE.HERO : CORE_GALLERY_SIZE.DESKTOP.HERO,
  });
  const src = get(coreMedia, 'heroImage.src');
  const imgUrl = getImageUrl(src, undefined, SOURCES.EDMUNDSCDN);
  return {
    href: imgUrl,
    as: 'image',
  };
}
